(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["i27-system"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  for (const disclosure of document.querySelectorAll('[data-i27-header] details[open]')) {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const disclosures = [...document.querySelectorAll('[data-i27-header] details[open]')];
  const active = disclosures.find((item) => item.contains(document.activeElement));
  for (const disclosure of disclosures) disclosure.open = false;
  if (active) active.querySelector('summary')?.focus();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["iuc-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = root => {
    root.querySelectorAll('.iuc-product').forEach(product => {
      if (product.dataset.iucReady) return;
      product.dataset.iucReady = 'true';
      const description = product.querySelector('[data-iuc-description]');
      if (description) {
        const headings = [...description.querySelectorAll('strong,b,h2,h3,h4')];
        const usage = headings.find(el => /directions for use|how to use|suggested use/i.test(el.textContent));
        const ingredients = headings.find(el => /contains per|contents of each|ingredients|composition/i.test(el.textContent));
        [[usage,'iuc-usage'],[ingredients,'iuc-ingredients']].forEach(([el,id]) => {
          if (!el) return;
          const old = product.querySelector('#'+id);
          if (old) old.removeAttribute('id');
          el.id = id;
          el.setAttribute('tabindex','-1');
        });
      }
      const slot = product.querySelector('[data-iuc-subscription-slot]');
      const quote = product.querySelector('[data-iuc-review-quote]');
      let scheduled = false;
      const enhance = () => {
        scheduled = false;
        if (slot) product.querySelectorAll('.sealsubs-target-element').forEach(widget => { if (!slot.contains(widget) && !widget.contains(slot)) slot.append(widget); });
        if (quote && quote.hidden) {
          const review = [...product.querySelectorAll('#judgeme_product_reviews .jdgm-rev')].find(el => el.querySelector('.jdgm-rev__rating[data-score="5"]') && (el.querySelector('.jdgm-rev__body')?.textContent.trim().length || 0) > 10);
          if (review) {
            const body = review.querySelector('.jdgm-rev__body').textContent.trim().replace(/\s+/g,' ');
            const author = review.querySelector('.jdgm-rev__author')?.textContent.trim();
            quote.querySelector('p').textContent = '“'+(body.length > 170 ? body.slice(0,167).replace(/\s+\S*$/,'')+'…' : body)+'”';
            quote.querySelector('cite').textContent = author || '';
            quote.hidden = false;
          }
        }
      };
      const changes = new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(enhance); } });
      changes.observe(product,{childList:true,subtree:true});
      enhance();
      const form = product.querySelector('[data-product-form]');
      if (form) {
        form.id = form.id || 'iuc-purchase-'+product.dataset.sectionId;
        const sticky = document.createElement('div');
        sticky.className = 'iuc-sticky';sticky.hidden = true;
        const title = document.createElement('strong');title.textContent = product.querySelector('h1').textContent.trim();
        const link = document.createElement('a');link.href = '#'+form.id;link.className = 'iuc-button iuc-button--dark';link.textContent = product.querySelector('.iuc-pack-label')?.textContent || product.querySelector('[data-add-to-cart-text]').textContent.trim();
        sticky.append(title,link);product.append(sticky);
        const visibility = new IntersectionObserver(entries => { const e=entries[0];sticky.hidden=e.isIntersecting || e.boundingClientRect.top > 0; });
        visibility.observe(form);
        link.addEventListener('click',()=>form.querySelector('input[name="quantity"],select,button')?.focus({preventScroll:true}));
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>setup(document),{once:true}); else setup(document);
  document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
  } catch(e) { console.error(e); }
})();

})();
